import {SubmissionsService} from "../submission.service";
import {CreateSubmissionDto} from "../types/types";
import {FileService} from "../file.service";

export async function submitWithOfflineSupport(
    formId: string,
    dto: CreateSubmissionDto
): Promise<{ online: boolean }> {
    try {
        // Subir imágenes base64 antes del POST (solo si hay conexión)
        const processedDto = await uploadPendingImages(dto);
        await SubmissionsService.create(formId, processedDto);
        return { online: true };
    } catch (error) {
        const isNetworkError =
            error instanceof Error && error.message === 'Network Error';

        if (!isNetworkError) throw error;
        // Si es PC, lanzar el error en vez de encolar
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isPWA = window.matchMedia('(display-mode: standalone)').matches;
        if (!isMobile && !isPWA) {
            throw new Error('No hay conexión a internet');
        }
        // Sin conexión → encolar con base64, el SW las subirá después
        const sw = await navigator.serviceWorker.ready;
        sw.active?.postMessage({
            type: 'QUEUE_SUBMISSION',
            payload: {
                url: `/api/submission/forms/${formId}/submit`,
                body: JSON.stringify(dto), // base64 incluido
                headers: { 'Content-Type': 'application/json' },
            },
        });

        return { online: false };
    }
}

async function uploadPendingImages(dto: CreateSubmissionDto): Promise<CreateSubmissionDto> {
    if (!dto.notes?.length) return dto;

    const processedNotes = await Promise.all(
        dto.notes.map(async (note) => {
            if (!note.imageBase64) return note;

            // Convertir base64 a File y subir
            const res = await fetch(note.imageBase64);
            const blob = await res.blob();
            const file = new File([blob], 'note-image.jpg', { type: blob.type });

            const formData = new FormData();
            formData.append('files', file);

            const { paths } = await FileService.upload(formData);
            const { imageBase64, ...noteWithoutBase64 } = note;
            return { ...noteWithoutBase64, imageUrl: paths[0] };
        })
    );

    return { ...dto, notes: processedNotes };
}